let _filter = {
  size: 10,
};

class Filter {
  get () {
    let localFilter;
    try {
      localFilter = JSON.parse(localStorage.getItem('_filter_product'));
    } catch (e) {
      localFilter = {};
    }
    return { ..._filter, ...localFilter };
  }

  set (filter) {
    _filter = {
      ..._filter,
      ...filter,
    };
    localStorage.setItem('_filter_product', JSON.stringify(_filter));
  }

  clear () {
    _filter = {
      page: 0,
      size: 10,
    };
    localStorage.setItem('_filter_product', JSON.stringify(_filter));
  }
}

export default new Filter();
